<template><v-card>
    <v-app-bar color="transparent" width="100%" elevation="0" class="justify-space-between py-2">
        <v-col cols="1" class="pl-0">
            <v-btn @click="$emit('close-view')" style="z-index: 10000" icon>
                <v-icon color="grey">mdi-chevron-left</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="11">
            <v-card-title class="ml-2 font-weight-bold">Krankenkassen Bestätigung</v-card-title>

            <!--
                        <v-img height="50px" @click="$router.push('/')" contain src="/img/roody_logo.png"></v-img>
                 -->
        </v-col>
    </v-app-bar>

    <v-card-text>
        <div v-for="(contractType, index) of contractTimespans" :key="'contractType' + index">
            <v-row no-gutters>
                <v-card-title>{{ contractType[0].title }}</v-card-title>

            </v-row>
            <v-row no-gutters>

                <v-col cols="12" v-for="(contract, index) of contractType" :key="'contract' + index">
                    <v-card class="mb-4 mx-2">
                        <v-row no-gutters>

                            <v-col cols="10">
                                <v-card-title>
                                    {{ contractType.length - index }}. Laufzeit ({{ $moment(contract.start,
                                        'DD.MM.YYYY').format('YYYY') }})
                                </v-card-title>
                                <v-card-subtitle>
                                    von {{ contract.start }} bis {{ contract.end }}
                                </v-card-subtitle>

                            </v-col>
                            <v-col cols="2" class="align-content-center">
                                <v-btn @click="requestHealthcareFile(contract)" icon large color="red">
                                    <v-icon>mdi-file-lock</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </div>

    </v-card-text>
    <v-dialog v-model="unlockDialog" persistent max-width="600px">
		<v-card>
			<v-card-title class="text-h5">Bestätigung erforderlich</v-card-title>
			<v-card-text> Die Krankenkassenbestätigung für diesen Vertrag wurde noch nicht von uns freigeschaltet.
				Möchtest du die Freischaltung beantragen? </v-card-text>
			<v-card-actions>
				<v-btn color="red darken-1" text @click="unlockDialog = false">Abbrechen</v-btn>
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" text @click="
					unlockDialog = false
				sendUnlockRequest()
					">
					Beantragen
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
    <v-dialog v-model="showWaitingDialog" persistent max-width="600px">
        <v-card>
            <v-card-title class="text-h5">Anfrage gesendet</v-card-title>
            <v-card-text> Deine Anfrage wurde erfolgreich gesendet. Wir werden die Freischaltung so schnell wie möglich
                durchführen. </v-card-text>
            <v-card-actions>
                <v-btn color="green darken-1" text @click="showWaitingDialog = false">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-card></template>

<script>
import api from '@/api'

export default {
    props: {
        showDialog: {
            type: Boolean,
        },
    },
    data() {
        return {
            customerInfos: null,
            loadingTACContract: true,
            error: false,
            contract: null, // Hinzugefügt
            allExistingContracts: null, // Hinzugefügt
            transactions: null, // Hinzugefügt
            fixTermTimesMissingBefore: [],
            fixTermTimesMissingAfter: [],
            allTransactions: [], // Hinzugefügt
            loadingTACContract: false,
            contractEndDate: null,
            allIdlePeriods: [], // Hinzugefügt, falls später im Code verwendet wird
            contractStartDate: null,
            contractInformations: null, // Hinzugefügt
            unlockDialog: false,
            selectedContract: null,
            showWaitingDialog: false,
        }
    },
    created() {
        this.init()
        this.fetchContracts()
    },
    methods: {
        closeForm() {
            this.$emit('closeForm')
        },
        requestHealthcareFile(contract) {
            console.log('asking for:', contract)
            this.selectedContract = contract
            this.unlockDialog = true
        },
        async fetchContracts() {
            let error = false
            let contract = null
            let transactions = []
            try {
                contract = await api.fetchTACMemberOwnContract()

                let allConts = await api.fetchTACAllMemberships()

                this.allExistingContracts = allConts.MemberDetails.MemberDetail
            } catch (e) {
                error = true
                console.log(e)
                alert(
                    'Wir konnten leider keine Mitgliedschaft für dich finden. Es kann sein, dass wir deine Mitgliedschaft mit einer anderen E-Mail Adresse hinterlegt haben. Bitte wende dich an das Personal um dies zu prüfen.'
                )
                this.$router.push('/user')
            }

            try {
                if (!error) {
                    transactions = await api.fetchAccountTransactionsForIDAdminTESTING(
                        contract.MemberDetail.Accounts.Account.find((acc) => acc.type === 'MEMBERSHIP').AccountID
                            .UniqueID[0].value,
                        this.$moment('2000-01-01', 'YYYY-MM-DD').format(),
                        this.$moment().add(4, 'years').format()
                    )
                }
            } catch (e) {
                await alert(
                    'Wir konnten leider keine Zahlungen für deine Mitgliedschaft finden. Falls dieses Problem trotz Zahlung auftritt, wende dich bitte an das Personal. '
                )
                this.$router.push('/user')
            }

            transactions.AccountTransactions.AccountTransactions.forEach((transaction) => {
                if (transaction.Type === 'IDLE_PERIOD') {
                    this.allTransactions.push({
                        start: transaction.IdlePeriodTimeRange.Start,
                        end: transaction.IdlePeriodTimeRange.End,
                        cost: transaction.Value,
                        state: transaction.State,
                        type: transaction.Type,
                        mainType: transaction.MainType,
                        det: transaction.AccountTransactionDetails,
                    })
                } else if (transaction.AccountTransactionDetails.AccountTransactionDetail[0].TimeRange) {
                    if (
                        transaction.AccountTransactionDetails.AccountTransactionDetail.find(
                            (det) => det.Description === 'Einschreibgebühr'
                        ) &&
                        !transaction.AccountTransactionDetails.AccountTransactionDetail.find(
                            (det) => det.Description === 'Erlass Fr. 99.00 Einschreibegebühr'
                        )
                    ) {
                        if (transaction.Value.value) {
                            transaction.Value.value -= 99
                        } else {
                            transaction.Value -= 99
                        }
                    }

                    /*    if (
                            transaction.AccountTransactionDetails.AccountTransactionDetail.find((det) =>
                                det.Description.includes('3 Jahres Abonnement')
                            )
                        ) {
                            if (transaction.Value.value) {
                                transaction.Value.value = Number(transaction.Value.value) + 570
                            } else {
                                transaction.Value = Number(transaction.Value) + 570
                            }
                        } */
                    let timeRange = transaction.AccountTransactionDetails.AccountTransactionDetail[0].TimeRange
                    this.allTransactions.push({
                        start: timeRange.Start,
                        end: timeRange.End,
                        cost: transaction.Value,
                        state: transaction.State,
                        type: transaction.Type,
                        mainType: transaction.MainType,
                    })
                }
            })

            this.contractInformations = JSON.parse(JSON.stringify(contract.MemberDetail))

            let timeSpans = contract.MemberDetail.ContractTermTimes.ContractTermTime
            let endTimeSpan = contract.MemberDetail.ContractTermTimes.ContractTermTime[timeSpans.length - 1]
            this.contractEndDate = this.$moment(endTimeSpan.TimeSpan.End, 'YYYY-MM-DD').format('DD.MM.YYYY')
            this.contractStartDate = this.$moment(
                timeSpans.reverse().find((ts) => ts.Type === 'DEFAULT').TimeSpan.Start,
                'YYYY-MM-DD'
            ).format('DD.MM.YYYY')
            this.loadingTACContract = false
        },
        async init() {
            let customer = await api.getOwnUserForManager()

            let customerEntry = {
                selection: customer._id,
                gender: customer.geschlecht,
                firstName: customer.vorname,
                lastName: customer.nachname,
                email: customer.email,
                phone: customer.telefon,
                birthday: customer.geburtstag,
                street: customer.adresse_1,
                city: customer.stadt,
                zip: customer.plz,
                signature: null,
            }
            this.customerInfos = customerEntry
        },
        bonusCalculatedFromMultipleTimespans(allTimeSpans, timeSpanDays) {
            const totalDays = allTimeSpans.reduce((total, timeSpan) => {
                return total + this.daysInTimeSpan(timeSpan)
            }, 0)

            return (
                Number(totalDays) === Number(timeSpanDays) ||
                Number(totalDays) - 1 === Number(timeSpanDays) ||
                Number(totalDays) + 1 === Number(timeSpanDays)
            )
        },
        daysInTimeSpan(timeSpan) {
            const start = this.$moment(timeSpan.TimeSpan.Start, 'YYYY-MM-DD')
            const end = this.$moment(timeSpan.TimeSpan.End, 'YYYY-MM-DD')
            return end.diff(start, 'days')
        },
        async sendUnlockRequest() {
			try {
				let status = await api.requestHealthcareUnlock({
					id: this.selectedContract.contractSequenceId,
					year: this.selectedContract.year,
					contract: {
						studio: this.selectedContractParent.studio,
						membershipName: this.selectedContractParent.membershipName,
						startDate: this.selectedContract.startDate,
						endDate: this.selectedContract.endDate,
						packages: this.selectedContract.packages,
					},
				})
				this.unlockDialog = false
				this.fetchContracts()
				this.fetchUser()
				this.showWaitingDialog = true
			} catch (e) {
				this.$toast.error('Ein Fehler ist aufgetreten, bitte versuche es erneut')
			}
		},
    },
    computed: {
        contractTimespans() {
            if (!this.allExistingContracts?.length) return []

            let allContracts = []
            for (let contract of this.allExistingContracts) {
                let timeSpans = contract.ContractTermTimes.ContractTermTime
                // console.log('before', this.fixTermTimesMissingBefore)
                //console.log('after', this.fixTermTimesMissingAfter)
                timeSpans = this.fixTermTimesMissingBefore.concat(timeSpans, this.fixTermTimesMissingAfter)

                //  console.log('am schluss gits: ', timeSpans)
                let activeContractDate = JSON.parse(JSON.stringify(timeSpans))
                    .reverse()
                    .find(
                        (ts) =>
                            ts.Type === 'DEFAULT' &&
                            !this.$moment(ts.TimeSpan.Start, 'YYYY-MM-DD').isAfter(this.$moment(), 'day')
                    ).TimeSpan.Start

                let contracts = []
                let newContract = null
                let idlePeriodTimeSpans = timeSpans.filter((timespan) => timespan.Type === 'IDLEPERIOD')
                timeSpans.forEach((timespan) => {
                    let filteredTimeSpans = JSON.parse(JSON.stringify(idlePeriodTimeSpans))
                    if (newContract) {
                        filteredTimeSpans = filteredTimeSpans.filter((filterTimeSpan) => {
                            return this.$moment(filterTimeSpan.TimeSpan.Start).isSameOrAfter(
                                this.$moment(newContract.start, 'DD.MM.YYYY')
                            )
                        })
                    }
                    if (timespan.Type === 'DEFAULT') {
                        if (
                            newContract &&
                            idlePeriodTimeSpans.length &&
                            (idlePeriodTimeSpans.find((idleTimeSpan) => {
                                return this.daysInTimeSpan(idleTimeSpan) === this.daysInTimeSpan(timespan)
                            }) ||
                                this.bonusCalculatedFromMultipleTimespans(filteredTimeSpans, this.daysInTimeSpan(timespan)))
                        ) {
                            newContract.timeStopBonus.push({
                                start: this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                                end: this.$moment(timespan.TimeSpan.End, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                            })
                        } else {
                            if (newContract !== null) contracts.push(newContract)
                            newContract = {
                                ContractID: timespan.ContractID.UniqueID[0].value,
                                title: contract.MemberCategoryName,
                                start: this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                                end: this.$moment(timespan.TimeSpan.End, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                                bonus: [],
                                timeStopBonus: [],
                                idlePeriods: [],
                                transactions:
                                    this.allTransactions.filter(
                                        (transaction) =>
                                            this.$moment(transaction.start, 'YYYY-MM-DD').isSameOrAfter(
                                                this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD')
                                            ) &&
                                            this.$moment(transaction.end, 'YYYY-MM-DD').isSameOrBefore(
                                                this.$moment(timespan.TimeSpan.End, 'YYYY-MM-DD')
                                            ) &&
                                            transaction.type !== 'IDLE_PERIOD'
                                    ) || [],
                                active: activeContractDate === timespan.TimeSpan.Start,
                                future: this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD').isAfter(this.$moment()),
                            }
                        }
                    }
                    if (timespan.Type === 'BONUSPERIOD') {
                        newContract.bonus.push({
                            start: this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                            end: this.$moment(timespan.TimeSpan.End, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                        })
                    }
                })
                contracts.push(newContract)
                idlePeriodTimeSpans.forEach((timespan) => {
                    let foundContract = contracts.find((cont) => {
                        let contEndDate = cont.timeStopBonus.length
                            ? cont.timeStopBonus[cont.timeStopBonus.length - 1].end
                            : cont.bonus.length
                                ? cont.bonus[cont.bonus.length - 1].end
                                : cont.end
                        return this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD').isBetween(
                            this.$moment(cont.start, 'DD.MM.YYYY'),
                            this.$moment(contEndDate, 'DD.MM.YYYY')
                        )
                    })

                    if (!foundContract) return

                    this.allIdlePeriods.push({
                        start: this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD'),
                        end: this.$moment(timespan.TimeSpan.End, 'YYYY-MM-DD'),
                    })
                    foundContract.idlePeriods.push({
                        transactions:
                            this.allTransactions.filter(
                                (transaction) =>
                                    this.$moment(transaction.start, 'YYYY-MM-DD').isSameOrAfter(
                                        this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD')
                                    ) &&
                                    this.$moment(transaction.end, 'YYYY-MM-DD').isSameOrBefore(
                                        this.$moment(timespan.TimeSpan.End, 'YYYY-MM-DD')
                                    )
                            ) || [],
                        start: this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                        end: this.$moment(timespan.TimeSpan.End, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                    })
                    this.existingTimestops.push({
                        start: this.$moment(timespan.TimeSpan.Start, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                        end: this.$moment(timespan.TimeSpan.End, 'YYYY-MM-DD').format('DD.MM.YYYY'),
                    })
                })
                if (!contracts.length && newContract && newContract.title) contracts.push(newContract)

                if (!contracts.find((cont) => cont.active && !cont.future)) contracts[contracts.length - 1].active = true
                if (allContracts.length) {
                    let pushed = false
                    for (let existingContract of allContracts) {
                        
                        if (existingContract.find(cont => cont.title === contracts[0].title)) {
                            for (let conti of contracts) {
                                existingContract.push(conti)
                            }
                            pushed = true
                        } 
                    }

                    if (!pushed) {
                        allContracts.push(contracts)
                    }
                } else {
                    allContracts.push(contracts)
                }
            }
            return allContracts.map((contract) => {
                return contract.reverse()
            })

        },
    },
}
</script>
